import { ButtonIcon, IconChevronLeft, spacer8, Type } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { useT } from '@spotify-internal/i18n-core';

const ButtonContainer = styled(ButtonIcon)`
  align-items: center;
`;

const ArrowIcon = styled(IconChevronLeft)`
  margin-right: ${spacer8};
`;

export default function BackButton({
  text,
  onClick,
  ...props
}: {
  text: string;
  onClick: () => void;
}) {
  const t = useT();
  return (
    <ButtonContainer
      semanticColor="textBrightAccent"
      aria-label={t('AL_BACKBUTTON_0', 'Back to {text} page', 'aria-label for Back button', {
        text,
      })}
      onClick={onClick}
      {...props}
    >
      <ArrowIcon />
      <Type variant="viola" weight="bold">
        {text}
      </Type>
    </ButtonContainer>
  );
}
